import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { useAppSelector } from "../../app/store/configureStore";
import { useForm } from "react-hook-form";
import { AnswersProps } from "../../app/models/Answers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  textbox: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const HappeningAtHome: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const { user } = useAppSelector((state) => state.account);

  const systemCodeId = user?.credentialTypeId === 4 ? 184 : 183;
  const defaultValues = {
    happening: answersData.find(
      (answer) => answer.systemCodeId === systemCodeId
    )?.answer,
  };
  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderHappeningAtHomeCompetence = () => {
    return (
      <>
        <li>
          What opportunities for daily communication do you provide to families?
        </li>
        <li>
          What are strategies or tools you use to document conversations and/or
          information shared by families regarding their child's home life?
        </li>
        <li>
          How do you schedule formal meetings with families on a consistent
          basis?
        </li>
        <li>How are families made aware of informal meeting opportunities?</li>
      </>
    );
  };

  return (
    <Grid container p={2} m={1}>
      <Grid item container>
        <Grid item xs={12}>
          <Typography fontWeight={700} mb={2}>
            CS IV-b - What's Happening at Home
          </Typography>
          <Typography mb={2}>
            {user?.credentialTypeId === 4
              ? `How do you ensure that you are aware of what's happening in each
            family's home life?`
              : "How do you make sure you are aware of what's happening in each child's home life?"}
          </Typography>
          <ReadMoreReadLess>
            <>{renderHappeningAtHomeCompetence()}</>
          </ReadMoreReadLess>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="I make sure I am aware of what's happening in each child's home life by"
            fullWidth
            multiline
            rows={2}
            {...register("happening")}
            name="happening"
            value={
              answersData.find((answer) => answer.systemCodeId === systemCodeId)
                ?.answer || ""
            }
            onChange={(e) => {
              const newValue = e.target.value;

              newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
            }}
            error={!!errors.happening?.message}
            helperText={errors.happening?.message}
          />
          <Typography fontSize={13}>
            {defaultValues.happening?.length}/500
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default HappeningAtHome;
